import { Box, Typography } from "@mui/material";
import dayjs, { Dayjs } from "dayjs";
import { ReactJSXElement } from "@emotion/react/types/jsx-namespace";
import { useEffect, useState } from "react";
import { useContextState } from "../../../../../../../../hooks/theme";
import { useStyles } from "./styles";


export const ChipDaysOla = ({ children, isNull, startDate, timeConfig, timer }: { children: ReactJSXElement, isNull: boolean, startDate?: { start: string; end: string | null; }[], timeConfig?: number, timer?: boolean }) => {

    const styles = useStyles();
    const { colors } = useContextState()
    const [bgColor, setBgColor] = useState(colors.color39);

    const calculateElapsedTime = () => {
        if (!startDate || startDate.length === 0) return 0;

        return startDate.reduce((total, { start, end }) => {
            const startTime = dayjs(start);
            const endTime = end ? dayjs(end) : dayjs(); // Si `end` es null, tomar la fecha actual
            return total + Math.max(endTime.diff(startTime, "milliseconds"), 0);
        }, 0);
    };

    const updateColor = () => {
        if (!timeConfig) {
            setBgColor(colors.color39);
            return;
        }

        const elapsedTime = calculateElapsedTime();
        const range = timeConfig / 3; // Dividir el tiempo en 3 partes
        if (elapsedTime < range) setBgColor(colors.color8); // Primer tramo
        else if (elapsedTime < range * 2) setBgColor(colors.color34); // Segundo tramo
        else setBgColor(colors.color19); // Último tramo
    };

    useEffect(() => {
        updateColor(); // Llamar la primera vez

        if (timer) {
            const interval = setInterval(updateColor, 1000); // Actualizar cada segundo si timer es true
            return () => clearInterval(interval);
        }
    }, [timeConfig, startDate, timer]);


    return (
        <Box sx={styles.daysContainer(bgColor)}>
            {isNull
                ?
                <Typography color="textSecondary" sx={{ fontWeight: 'bold' }}>00 días 00:00:00</Typography>
                :
                children
            }
        </Box>
    );
};
